import { FC, useMemo } from 'react';
import {
  Popup,
  TPopupComponent,
} from '../../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../../shared/components/popup/services/popup.service';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { Content } from './content.popup';
import { ITabState } from '../../../../../states/tabState.model';

export class ConnectBakery2bClientWithCustomer extends Popup<IConnectBakery2bClientWithCustomer> {
  Component: FC<TPopupComponent>;
  bakery2bAccountsOptions: ITabState['bakery2bTabOptions']['bakery2bAccounts'];
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 594 },
          '& > div > div > div': { padding: 0 },
        }));
      }, []);

      return (
        <SWrapper stream={stream} popupTitle={t('customer.add_bakery2b_account')}>
          <Content stream={stream} />
        </SWrapper>
      );
    };
  }
}

export interface IShortAccountInfo {
  email: string;
  name: string | null | undefined;
}
export interface IConnectBakery2bClientWithCustomer {
  action: TPopupDefaultActions;
  alreadyCreatredBakery2bAccs: IShortAccountInfo[];
  alreadyAddedBakery2bAccs: string[];
  customerId: string;
}
